import React from 'react';

const Footer = () => {

   return (
      <footer className = "footer">
         <div className = "text-center">
            { new Date().getFullYear() } &copy;
         </div>
      </footer>
   )
};

export default Footer;